module.exports = __webpack_public_path__ + "img/controlroom2.061563d0.jpg";